import React from 'react';
import {FeaturePopover, Main} from 'app/components/entities/cloud';
import {UnpaidFeature} from 'app/components/features/billing/edge';
import {UpgradeToEdgePremium} from 'app/components/sharedReactComponents/UpgradeToEdgePremium/UpgradeToEdgePremium';

interface Props {
  capability: Main.CapabilityState;
  paymentAccess: boolean;
  anchorEl: HTMLElement | null;
  setAnchorEl: (el: HTMLElement | null) => void;
}

export function EdgePopover({capability, paymentAccess, anchorEl, setAnchorEl}: Props) {
  const active = capability.enabled;

  return (
    <FeaturePopover anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
      {!active && capability.reason === 'subscription_is_dq' ? (
        <UnpaidFeature paymentAccess={paymentAccess} />
      ) : (
        <UpgradeToEdgePremium paymentAccess={paymentAccess} />
      )}
    </FeaturePopover>
  );
}
